import { render, staticRenderFns } from "./CApp.vue?vue&type=template&id=3ebbffa6"
import script from "./CApp.vue?vue&type=script&lang=js"
export * from "./CApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ebbffa6')) {
      api.createRecord('3ebbffa6', component.options)
    } else {
      api.reload('3ebbffa6', component.options)
    }
    module.hot.accept("./CApp.vue?vue&type=template&id=3ebbffa6", function () {
      api.rerender('3ebbffa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CApp.vue"
export default component.exports